import React, { useEffect, useMemo, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "../../utils/axiosConfig";
import { formatReportDate } from "../../utils/reportDate";
import "./CrystalReports.css";

const REPORTS = [
  { key: "buyer", label: "Buyer Report", file: "rptNewBuyerRpt.rpt" },
  { key: "shipper", label: "Shipper Report", file: "rptNewShipperRpt.rpt" },
  { key: "sc-pending", label: "SC Pending Report", file: "rptSCPending.rpt" },
  { key: "sc-detail", label: "SC Detail Report", file: "rptSCDtl.rpt" },
  { key: "followup", label: "FollowUp Detail Report", file: "rptFollowUpDtl.rpt" },
  { key: "fixation-note", label: "Fixation Notice Report", file: "rptFixationNotice.rpt" },
  { key: "deal-fixation-note", label: "Deal Fixation Notice Report", file: "rptFixationNotice_For_Whole_Deal.rpt" },
  { key: "commission", label: "Commission Report", file: "rptCommission.rpt" },
  { key: "shipment-pending", label: "Shipment Pending Report", file: "rptShipmentPending.rpt" },
  { key: "copy-doc-pending", label: "Copy Document Pending Report", file: "rptCopyDocPending.rpt" },
  { key: "advance-pending", label: "Advance Pending Report", file: "rptAdvancePending.rpt" },
  { key: "deal-status", label: "Deal Status Report", file: "rptDealStatus.rpt" },
  { key: "sales", label: "Sales Report", file: "rptSales.rpt" },
  { key: "shipment-due", label: "Shipment Due Report", file: "rptShipmentDue.rpt" },
  { key: "sales-contract-due", label: "Sales Contract Due Report", file: "rptSalesContractDue.rpt" },
  { key: "doc-release-pending", label: "Document Release Pending Report", file: "DocReleasePending.rpt" },
  { key: "invoice-list", label: "Invoice List Report", file: "rptInvoiceList.rpt" },
  { key: "pending-invoice", label: "Pending Invoice Report", file: "rptPendingInvoice.rpt" },
  { key: "shipment-advice", label: "Shipment Advice Report", file: "rptShipmentAdvice.rpt" },
  { key: "bill-of-lading", label: "Bill Of Lading Report", file: "rptBillOfLading.rpt" },
  { key: "inward-remittance", label: "Inward Remittance Report", file: "rptInwardRemittance.rpt" },
  { key: "payment-advice", label: "Payment Advice Report", file: "rptPaymentAdvice.rpt" },
  { key: "sales-turnover", label: "Sales Turnover Report", file: "rptSalesTurnover.rpt" },
  { key: "weight", label: "Weight Report", file: "rptWeight.rpt" },
  { key: "quality", label: "Quality Report", file: "rptQuality.rpt" },
  { key: "document-dispatch-advice", label: "Document Dispatch Advice Report", file: "rptDocumentDispatchAdvice.rpt" },
  { key: "internal-invoice", label: "Internal Invoice Report", file: "rptInternalInvoice.rpt" },
  { key: "final-buyer", label: "Final Buyer Report", file: "rptFinalBuyer.rpt" },
  { key: "full-buyer-detail", label: "Full Buyer Detail Report", file: "rptFullBuyerDtl.rpt" },
  { key: "full-shipper-detail", label: "Full Shipper Detail Report", file: "rptFullShipperDtl.rpt" },
  { key: "common-fixation", label: "Common Fixation Report", file: "rptCommonFixation.rpt" },
  { key: "supplier-statement", label: "Supplier Statement Report", file: "rptSupplierStatement.rpt" },
  { key: "external-supplier-statement", label: "External Supplier Statement Report", file: "rptExternalSupplierStatement.rpt" },
  { key: "buyer-detail", label: "Buyer Detail Report", file: "rptBuyerDetail.rpt" },
  { key: "shipper-detail", label: "Shipper Detail Report", file: "rptShipperDetail.rpt" },
  { key: "sales-contract-pending", label: "Sales Contract Pending Report", file: "rptSalesContractPending.rpt" },
  { key: "deal-status-revised", label: "Deal Status Revised Report", file: "rptDealStatus_revised.rpt" },
  { key: "invoice", label: "Invoice Report", file: "rptInvoice.rpt" },
  { key: "buyer-summary", label: "Buyer Summary Report", file: "rptbuyer.rpt" },
  { key: "buyer-contact-detail", label: "Buyer Contact Detail Report", file: "rptBuyerContactDetail.rpt" },
  { key: "buyer-dtl", label: "Buyer Dtl Report", file: "rptBuyerDtl.rpt" },
  { key: "buyer-detail-test", label: "Buyer Detail Test Report", file: "rptBuyerDtltest1.rpt" },
  { key: "buyer-detail-label", label: "Buyer Detail Label Report", file: "rptBuyerDtl_Label.rpt" },
  { key: "shipper-summary", label: "Shipper Summary Report", file: "rptShipper.rpt" },
  { key: "shipper-contact-detail", label: "Shipper Contact Detail Report", file: "rptShipperContactDetail.rpt" },
  { key: "shipper-dtl", label: "Shipper Dtl Report", file: "rptShipperDtl.rpt" },
  { key: "shipper-detail-label", label: "Shipper Detail Label Report", file: "rptShipperDtl_Label.rpt" },
  { key: "shipper-test", label: "Shipper Test Report", file: "rptShippertest.rpt" },
];

const PARTY_REPORT_KEYS = [
  "buyer", "shipper", "full-buyer-detail", "full-shipper-detail", "buyer-detail", "shipper-detail",
  "buyer-summary", "buyer-contact-detail", "buyer-dtl", "buyer-detail-test", "buyer-detail-label",
  "shipper-summary", "shipper-contact-detail", "shipper-dtl", "shipper-detail-label", "shipper-test"
];

const MONTHS = ["Yearly", "January", "February", "March", "April", "May", "June",
  "July", "August", "September", "October", "November", "December"];

const today = new Date().toISOString().slice(0, 10);

const emptyFilters = {
  companyName: "",
  personName: "",
  countryId: "",
  state: "",
  city: "",
  contactGroupIds: [],
  dealId: "",
  fixationId: "",
  shipperId: "",
  month: "Yearly",
  currency: "USD",
  fromDate: today,
  toDate: today,
};

const formatDate = (value) => {
  if (!value) return "";
  return formatReportDate(value, String(value));
};

const formatNumber = (value, decimals = 2) => {
  const number = Number(value);
  if (!Number.isFinite(number)) return "";
  return number.toLocaleString("en-IN", { minimumFractionDigits: decimals, maximumFractionDigits: decimals });
};

const text = (...values) => values.filter(Boolean).join(", ");

const downloadCsv = (rows, name) => {
  const csv = rows.map((row) => row.map((value) => `"${String(value ?? "").replace(/"/g, '""')}"`).join(",")).join("\n");
  const blob = new Blob([csv], { type: "text/csv;charset=utf-8" });
  const link = document.createElement("a");
  link.href = URL.createObjectURL(blob);
  link.download = `${name}.csv`;
  link.click();
  URL.revokeObjectURL(link.href);
};

const exportCsv = (report) => {
  if (!report) return;
  const rows = [];
  const key = report.report.key;

  if (PARTY_REPORT_KEYS.includes(key)) {
    rows.push(["Name", "Full Name", "Address", "City", "State", "Country", "Phone", "Mobile", "Email", "Contact Person", "Contact Groups"]);
    report.parties.forEach((party) => {
      rows.push([party.PartyName, party.FullName, party.Address, party.City, party.StateName || party.State, party.CountryName, party.Phone, party.Mobile, party.Email, party.ContactPerson, party.ContactGroups]);
      party.contacts.forEach((contact) => {
        rows.push(["", `Contact: ${contact.ContactPerson || ""}`, "", "", "", "", contact.ContactNo, contact.MobileNo, contact.Email, contact.Designation, contact.Department]);
      });
    });
  } else if (key === "commission") {
    rows.push(["Supplier", "Deal No", "Deal Date", "Buyer", "SC No", "Containers", "Weight", "Type", "Rate", "Buyer Commission", "Supplier Commission", "Total Commission", "Currency"]);
    report.suppliers.forEach((supplier) => supplier.rows.forEach((row) => {
      rows.push([supplier.shipperName, row.DealNo || row.DealID, formatDate(row.DealDate), row.BuyerName, row.SCNo, row.NoOfContainer, row.Weight, row.CommissionType, row.CommissionPct, row.BuyerCommissionAmount, row.SupplierCommissionAmount, row.TotalCommission, row.Currency]);
    }));
  } else {
    const columns = report.columns?.length
      ? report.columns
      : [
          { key: "DealNo", label: "Deal No", type: "text" },
          { key: "DealDate", label: "Deal Date", type: "date" },
          { key: "ShipperName", label: "Supplier", type: "text" },
          { key: "BuyerName", label: "Buyer", type: "text" },
          { key: "PONo", label: "PO No", type: "text" },
          { key: "PORecDate", label: "PO Date", type: "date" },
          { key: "SCRNo", label: "SC No", type: "text" },
          { key: "SCRDate", label: "SC Date", type: "date" },
          { key: "NoOfContainer", label: "Containers", type: "number", decimals: 0 },
          { key: "TotalQty", label: "Qty", type: "number" },
          { key: "DealCurrency", label: "Currency", type: "text" },
        ];
    rows.push(columns.map((column) => column.label));
    (report.rows || []).forEach((deal) => {
      const shipments = columns.some(column => column.shipment) && deal.Shipments?.length ? deal.Shipments : [null];
      shipments.forEach(shipment => rows.push(columns.map((column) => {
        const row = column.shipment ? shipment || {} : deal;
        return column.key === "InvoiceAmount" && deal.TurnoverPending ? "Pending" :
      column.type === "date"
        ? formatDate(row[column.key])
        : column.type === "number"
          ? formatNumber(row[column.key], column.decimals ?? 2)
          : row[column.key] ?? ""
      })));
    });
  }

  downloadCsv(rows, key);
};

const PartyReport = ({ report }) => (
  <>
    <div className="crystal-summary-row">
      <span>Total Records: <b>{report.parties.length}</b></span>
      <span>Total Contacts: <b>{report.totalContacts}</b></span>
    </div>
    {report.parties.length === 0 ? (
      <div className="crystal-empty">No records found.</div>
    ) : report.parties.map((party, index) => (
      <section className="crystal-party-block" key={party.PartyID || index}>
        <div className="crystal-party-title">
          <span>{index + 1}. {party.PartyName || "-"}</span>
          <span>{party.ContactGroups || ""}</span>
        </div>
        <table className="crystal-detail-table">
          <tbody>
            <tr><th>Full Name</th><td>{party.FullName || "-"}</td><th>Contact Person</th><td>{party.ContactPerson || "-"}</td></tr>
            <tr><th>Address</th><td colSpan="3">{text(party.Address, party.Area, party.City, party.StateName || party.State, party.CountryName, party.Zip) || "-"}</td></tr>
            <tr><th>Phone</th><td>{text(party.Phone, party.Fax) || "-"}</td><th>Mobile / Email</th><td>{text(party.Mobile, party.Email) || "-"}</td></tr>
            {party.Remark && <tr><th>Remark</th><td colSpan="3">{party.Remark}</td></tr>}
          </tbody>
        </table>
        <table className="crystal-report-table crystal-contact-table">
          <thead><tr><th>Contact Person</th><th>Designation</th><th>Department</th><th>Contact No</th><th>Mobile</th><th>Email</th></tr></thead>
          <tbody>
            {party.contacts.length === 0 ? (
              <tr><td colSpan="6" className="crystal-muted">No contact details</td></tr>
            ) : party.contacts.map((contact, contactIndex) => (
              <tr key={contactIndex}>
                <td>{contact.ContactPerson || ""}</td><td>{contact.Designation || ""}</td><td>{contact.Department || ""}</td>
                <td>{text(contact.ISD_Code, contact.ContactNo) || ""}</td><td>{contact.MobileNo || ""}</td><td>{contact.Email || ""}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </section>
    ))}
  </>
);

const ScPendingReport = ({ report }) => (
  <>
    <div className="crystal-summary-row">
      <span>From Date: <b>{report.criteria.fromDateLabel || "-"}</b></span>
      <span>To Date: <b>{report.criteria.toDateLabel || "-"}</b></span>
      <span>Total Deals: <b>{report.totals.deals}</b></span>
    </div>
    <table className="crystal-report-table">
      <thead><tr><th>Sr.</th><th>Deal No</th><th>Deal Date</th><th>Supplier</th><th>Buyer</th><th>PO No</th><th>PO Date</th><th>Containers</th><th>Qty</th><th>Currency</th></tr></thead>
      <tbody>
        {report.rows.length === 0 ? (
          <tr><td colSpan="10" className="crystal-empty">No records found.</td></tr>
        ) : report.rows.map((row, index) => (
          <tr key={`${row.DealID}-${index}`}>
            <td className="num">{index + 1}</td><td>{row.DealNo || row.DealID}</td><td>{formatDate(row.DealDate)}</td><td>{row.ShipperName || ""}</td><td>{row.BuyerName || ""}</td>
            <td>{row.PONo || ""}</td><td>{formatDate(row.PORecDate)}</td><td className="num">{formatNumber(row.NoOfContainer, 0)}</td><td className="num">{formatNumber(row.TotalQty)}</td><td>{row.DealCurrency || ""}</td>
          </tr>
        ))}
      </tbody>
      <tfoot><tr><td colSpan="7">Total</td><td className="num">{formatNumber(report.totals.containers, 0)}</td><td className="num">{formatNumber(report.totals.quantity)}</td><td></td></tr></tfoot>
    </table>
  </>
);

const ScDetailReport = ({ report }) => (
  <>
    <div className="crystal-summary-row">
      <span>From Date: <b>{report.criteria.fromDateLabel || "-"}</b></span>
      <span>To Date: <b>{report.criteria.toDateLabel || "-"}</b></span>
      <span>Total Deals: <b>{report.totals.deals}</b></span>
    </div>
    {report.rows.length === 0 ? <div className="crystal-empty">No records found.</div> : report.rows.map((deal, index) => {
      const items = report.itemsByDeal?.[String(deal.DealID)] || [];
      return (
        <section className="crystal-party-block" key={`${deal.DealID}-${index}`}>
          <div className="crystal-party-title"><span>{index + 1}. Deal {deal.DealNo || deal.DealID}</span><span>{formatDate(deal.DealDate)}</span></div>
          <table className="crystal-detail-table">
            <tbody>
              <tr><th>Supplier</th><td>{deal.ShipperName || "-"}</td><th>Buyer</th><td>{deal.BuyerName || "-"}</td></tr>
              <tr><th>PO No / Date</th><td>{text(deal.PONo, formatDate(deal.PORecDate)) || "-"}</td><th>SC No / Date</th><td>{text(deal.SCRNo, formatDate(deal.SCRDate)) || "-"}</td></tr>
              <tr><th>Containers</th><td className="num">{formatNumber(deal.NoOfContainer, 0)}</td><th>Qty / Currency</th><td>{text(formatNumber(deal.TotalQty), deal.DealCurrency) || "-"}</td></tr>
              <tr><th>Fixed</th><td className="num">{formatNumber(deal.FixedAmount)}</td><th>Unfixed</th><td className="num">{formatNumber(deal.UnFixedAmount)}</td></tr>
            </tbody>
          </table>
          <table className="crystal-report-table crystal-contact-table">
            <thead><tr><th>Item</th><th>Commodity</th><th>Supplier Material</th><th>Buyer Material</th><th>Qty</th><th>Rate</th><th>Price Mode</th><th>LME</th></tr></thead>
            <tbody>
              {items.length === 0 ? <tr><td colSpan="8" className="crystal-muted">No item details</td></tr> : items.map((item, itemIndex) => (
                <tr key={item.DealItemID || itemIndex}>
                  <td>{text(item.ItemCode, item.ItemName) || item.ItemId || ""}</td><td>{item.Commodity || ""}</td><td>{item.MaterialSupplier || ""}</td><td>{item.MaterialBuyer || ""}</td>
                  <td className="num">{formatNumber(item.Quantity)}</td><td className="num">{formatNumber(item.Rate)}</td><td>{item.PriceMode || ""}</td><td className="num">{formatNumber(item.LME, 4)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </section>
      );
    })}
  </>
);

const FollowupReport = ({ report }) => (
  <>
    <div className="crystal-summary-row">
      <span>From Date: <b>{report.criteria.fromDateLabel || "-"}</b></span>
      <span>To Date: <b>{report.criteria.toDateLabel || "-"}</b></span>
      <span>Total Followups: <b>{report.totals.followups}</b></span>
    </div>
    <table className="crystal-report-table">
      <thead><tr><th>Sr.</th><th>Followup Date</th><th>Deal No</th><th>Deal Date</th><th>Supplier</th><th>Buyer</th><th>Remarks</th><th>Created By</th></tr></thead>
      <tbody>
        {report.rows.length === 0 ? <tr><td colSpan="8" className="crystal-empty">No records found.</td></tr> : report.rows.map((row, index) => (
          <tr key={row.FollowupID || index}>
            <td className="num">{index + 1}</td><td>{formatDate(row.FollowupDate)}</td><td>{row.DealNo || row.DealID}</td><td>{formatDate(row.DealDate)}</td>
            <td>{row.ShipperName || ""}</td><td>{row.BuyerName || ""}</td><td>{row.Remarks || ""}</td><td>{row.CreatedBy || ""}</td>
          </tr>
        ))}
      </tbody>
    </table>
  </>
);

const FixationReport = ({ report }) => (
  <>
    <div className="crystal-summary-row">
      <span>From Date: <b>{report.criteria.fromDateLabel || "-"}</b></span>
      <span>To Date: <b>{report.criteria.toDateLabel || "-"}</b></span>
      <span>Total Fixations: <b>{report.totals.fixations}</b></span>
    </div>
    {report.rows.length === 0 ? <div className="crystal-empty">No records found.</div> : report.rows.map((row, index) => (
      <section className="crystal-party-block" key={row.FixationID || index}>
        <div className="crystal-party-title"><span>{index + 1}. Fixation {row.FixationID}</span><span>{formatDate(row.CreatedDate)}</span></div>
        <table className="crystal-detail-table">
          <tbody>
            <tr><th>Deal No</th><td>{row.DealNo || row.DealID}</td><th>Deal Date</th><td>{formatDate(row.DealDate)}</td></tr>
            <tr><th>Supplier</th><td>{row.ShipperName || "-"}</td><th>Buyer</th><td>{row.BuyerName || "-"}</td></tr>
            <tr><th>Fixation</th><td colSpan="3">{row.Fixation || "-"}</td></tr>
          </tbody>
        </table>
      </section>
    ))}
  </>
);

const CommissionCrystalReport = ({ report }) => (
  <>
    <div className="crystal-summary-row">
      <span>Period: <b>{report.criteria.period}</b></span>
      <span>Currency: <b>{report.criteria.currency}</b></span>
      <span>Total Suppliers: <b>{report.totals.suppliers}</b></span>
    </div>
    {report.suppliers.length === 0 ? <div className="crystal-empty">No records found.</div> : report.suppliers.map((supplier) => (
      <section className="crystal-party-block" key={supplier.shipperId || supplier.shipperName}>
        <div className="crystal-party-title"><span>Supplier: {supplier.shipperName}</span><span>Total Commission: {formatNumber(supplier.totalCommission)} {report.criteria.currency}</span></div>
        <table className="crystal-report-table">
          <thead><tr><th>Sr.</th><th>Deal No</th><th>Date</th><th>Buyer</th><th>SC No</th><th>Containers</th><th>Weight</th><th>Type</th><th>Rate</th><th>Buyer Comm.</th><th>Supplier Comm.</th><th>Total Comm.</th></tr></thead>
          <tbody>{supplier.rows.map((row, index) => (
            <tr key={`${row.CommissionID || "deal"}-${row.DealID}-${index}`}>
              <td className="num">{index + 1}</td><td>{row.DealNo || row.DealID}</td><td>{formatDate(row.DealDate)}</td><td>{row.BuyerName || ""}</td><td>{row.SCNo || ""}</td>
              <td className="num">{formatNumber(row.NoOfContainer, 0)}</td><td className="num">{formatNumber(row.Weight, 3)}</td><td>{row.CommissionType}</td>
              <td className="num">{row.CommissionType === "Lumpsum" ? formatNumber(row.Lumpsum) : `${formatNumber(row.CommissionPct, 4)}${row.IsPercent ? "%" : "/T"}`}</td>
              <td className="num">{formatNumber(row.BuyerCommissionAmount)}</td><td className="num">{formatNumber(row.SupplierCommissionAmount)}</td><td className="num">{formatNumber(row.TotalCommission)}</td>
            </tr>
          ))}</tbody>
        </table>
      </section>
    ))}
    <div className="crystal-summary-row">
      <span>Deals: <b>{report.totals.deals}</b></span>
      <span>Weight: <b>{formatNumber(report.totals.weight, 3)}</b></span>
      <span>Commission: <b>{formatNumber(report.totals.commission)} {report.criteria.currency}</b></span>
    </div>
  </>
);

const GenericCrystalReport = ({ report }) => {
  const columns = report.columns || [];
  const renderValue = (row, column) => {
    if (report.report.key === "sales-turnover" && column.key === "InvoiceAmount" && row.TurnoverPending) return "Pending";
    if (column.type === "date") return formatDate(row[column.key]);
    if (column.type === "number") return formatNumber(row[column.key], column.decimals ?? 2);
    return row[column.key] ?? "";
  };

  return (
    <>
      <div className="crystal-summary-row">
        <span>From Date: <b>{report.criteria.fromDateLabel || "-"}</b></span>
        <span>To Date: <b>{report.criteria.toDateLabel || "-"}</b></span>
        <span>Total Deals: <b>{report.totals.deals}</b></span>
        <span>Qty: <b>{formatNumber(report.totals.quantity, 3)}</b></span>
        <span>Containers: <b>{formatNumber(report.totals.containers, 0)}</b></span>
      </div>
      <div className="crystal-table-scroll">
        <table className="crystal-report-table">
          <thead>
            <tr>
              <th>Sr.</th>
              {columns.map((column) => <th key={column.key}>{column.label}</th>)}
            </tr>
          </thead>
          <tbody>
            {report.rows.length === 0 ? (
              <tr><td colSpan={columns.length + 1} className="crystal-empty">No records found.</td></tr>
            ) : report.rows.flatMap((row, index) => {
              const shipments = columns.some(column => column.shipment) && row.Shipments?.length ? row.Shipments : [null];
              return shipments.map((shipment, shipmentIndex) => (
                <tr key={`${row.DealID || "deal"}-${index}-${shipmentIndex}`}>
                  {shipmentIndex === 0 && <td rowSpan={shipments.length} className="num">{index + 1}</td>}
                  {columns.map(column => column.shipment ? (
                    <td key={column.key} className={column.type === "number" ? "num" : ""}>{renderValue(shipment || {}, column)}</td>
                  ) : shipmentIndex === 0 ? (
                    <td key={column.key} rowSpan={shipments.length} className={column.type === "number" ? "num" : ""}>{renderValue(row, column)}</td>
                  ) : null)}
                </tr>
              ));
            })}
          </tbody>
        </table>
      </div>
      <div className="crystal-summary-row">
        <span>Shipped Weight: <b>{formatNumber(report.totals.shippedWeight, 3)}</b></span>
        <span>Invoice Amount: <b>{formatNumber(report.totals.invoiceAmount)}</b></span>
        <span>Advance Balance: <b>{formatNumber(report.totals.balanceAdvance)}</b></span>
      </div>
      {report.totals.pendingTurnoverDeals > 0 && <p>Turnover is pending for {report.totals.pendingTurnoverDeals} deal(s) because invoice amounts or pricing are missing. The total includes completed amounts only.</p>}
    </>
  );
};

const ReportBody = ({ report }) => {
  if (report.report.key === "sc-pending") return <ScPendingReport report={report} />;
  if (report.report.key === "sc-detail") return <ScDetailReport report={report} />;
  if (report.report.key === "followup") return <FollowupReport report={report} />;
  if (report.report.key === "fixation-note" || report.report.key === "deal-fixation-note") return <FixationReport report={report} />;
  if (report.report.key === "commission") return <CommissionCrystalReport report={report} />;
  if (report.columns) return <GenericCrystalReport report={report} />;
  return <PartyReport report={report} />;
};

const CrystalReports = () => {
  const { reportType: routeReportType } = useParams();
  const reportType = REPORTS.some((item) => item.key === routeReportType) ? routeReportType : "buyer";
  const [filters, setFilters] = useState(emptyFilters);
  const [options, setOptions] = useState({ countries: [], contactGroups: [], deals: [], suppliers: [], currencies: [], fixations: [] });
  const [report, setReport] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    let isMounted = true;
    const emptyOptions = { countries: [], contactGroups: [], deals: [], suppliers: [], currencies: [], fixations: [] };

    const loadOptions = async () => {
      try {
        const res = await axios.get("/report/legacy-crystal/options");
        if (isMounted) setOptions({ ...emptyOptions, ...res.data });
      } catch (_err) {
        try {
          const res = await axios.get("/report/legacy-first-three/options");
          if (isMounted) setOptions({ ...emptyOptions, ...res.data });
        } catch (_fallbackErr) {
          if (isMounted) setOptions(emptyOptions);
        }
      }
    };

    loadOptions();
    return () => {
      isMounted = false;
    };
  }, []);

  useEffect(() => {
    setReport(null);
    setError("");
  }, [reportType]);

  const selectedReport = useMemo(() => REPORTS.find((item) => item.key === reportType), [reportType]);
  const isPartyReport = PARTY_REPORT_KEYS.includes(reportType);
  const isCommissionReport = reportType === "commission";
  const isFixationReport = reportType === "fixation-note" || reportType === "deal-fixation-note";
  const company = report?.company || {};

  const setFilter = (key, value) => setFilters((current) => ({ ...current, [key]: value }));

  const toggleGroup = (groupId) => {
    const value = String(groupId);
    setFilters((current) => ({
      ...current,
      contactGroupIds: current.contactGroupIds.includes(value)
        ? current.contactGroupIds.filter((item) => item !== value)
        : [...current.contactGroupIds, value],
    }));
  };

  const generate = async () => {
    try {
      setLoading(true);
      setError("");
      setReport(null);
      const payload = isPartyReport
        ? {
            companyName: filters.companyName,
            personName: filters.personName,
            countryId: filters.countryId,
            state: filters.state,
            city: filters.city,
            contactGroupIds: filters.contactGroupIds,
          }
        : isCommissionReport
          ? {
              shipperId: filters.shipperId,
              month: filters.month,
              currency: filters.currency,
            }
          : {
              dealId: filters.dealId,
              fixationId: isFixationReport ? filters.fixationId : "",
              fromDate: filters.fromDate,
              toDate: filters.toDate,
            };
      const res = await axios.post(`/report/legacy-crystal/${reportType}`, payload);
      setReport(res.data);
    } catch (err) {
      setError(err.response?.data?.message || "Failed to generate report.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="crystal-page">
      <section className="crystal-toolbar no-print">
        <div className="crystal-report-title">
          <span>Crystal Reports</span>
          <strong>{selectedReport.label}</strong>
          <small>{selectedReport.file}</small>
        </div>

        <div className="crystal-filter-grid">
          {isPartyReport ? (
            <>
              <label>Company Name<input value={filters.companyName} onChange={(event) => setFilter("companyName", event.target.value)} /></label>
              <label>Person Name<input value={filters.personName} onChange={(event) => setFilter("personName", event.target.value)} /></label>
              <label>Country<select value={filters.countryId} onChange={(event) => setFilter("countryId", event.target.value)}>
                <option value="">All</option>
                {options.countries.map((country) => <option key={country.CountryId} value={country.CountryId}>{country.CountryName}</option>)}
              </select></label>
              <label>State<input value={filters.state} onChange={(event) => setFilter("state", event.target.value)} /></label>
              <label>City<input value={filters.city} onChange={(event) => setFilter("city", event.target.value)} /></label>
              <div className="crystal-group-filter">
                <span>Contact Group</span>
                <div>
                  {options.contactGroups.map((group) => (
                    <label key={group.GroupId}>
                      <input type="checkbox" checked={filters.contactGroupIds.includes(String(group.GroupId))} onChange={() => toggleGroup(group.GroupId)} />
                      {group.GroupDesc}
                    </label>
                  ))}
                </div>
              </div>
            </>
          ) : isCommissionReport ? (
            <>
              <label>Supplier<select value={filters.shipperId} onChange={(event) => setFilter("shipperId", event.target.value)}>
                <option value="">All Suppliers</option>
                {options.suppliers.map((supplier) => <option key={supplier.ShipperID} value={supplier.ShipperID}>{supplier.ShipperName}</option>)}
              </select></label>
              <label>Month<select value={filters.month} onChange={(event) => setFilter("month", event.target.value)}>
                {MONTHS.map((month) => <option key={month} value={month}>{month}</option>)}
              </select></label>
              <label>Currency<select value={filters.currency} onChange={(event) => setFilter("currency", event.target.value)}>
                {(options.currencies.length ? options.currencies : [{ Currency_Id: "USD", Code: "USD" }]).map((currency) => <option key={currency.Currency_Id || currency.Code} value={currency.Code}>{currency.Code}</option>)}
              </select></label>
            </>
          ) : (
            <>
              <label>Deal<select value={filters.dealId} onChange={(event) => setFilter("dealId", event.target.value)}>
                <option value="">Select Deal</option>
                {options.deals.map((deal) => <option key={deal.DealID} value={deal.DealID}>{deal.DealNo || deal.DealID}</option>)}
              </select></label>
              {isFixationReport && <label>Fixation<select value={filters.fixationId} onChange={(event) => setFilter("fixationId", event.target.value)}>
                <option value="">All Fixations</option>
                {options.fixations.map((fixation) => <option key={fixation.FixationID} value={fixation.FixationID}>{text(fixation.DealNo || fixation.DealID, `#${fixation.FixationID}`)}</option>)}
              </select></label>}
              <label>From Date<input type="date" value={filters.fromDate} onChange={(event) => setFilter("fromDate", event.target.value)} disabled={Boolean(filters.dealId || filters.fixationId)} /></label>
              <label>To Date<input type="date" value={filters.toDate} onChange={(event) => setFilter("toDate", event.target.value)} disabled={Boolean(filters.dealId || filters.fixationId)} /></label>
            </>
          )}
        </div>

        {error && <div className="crystal-error">{error}</div>}
        <div className="crystal-actions">
          <button type="button" onClick={generate} disabled={loading}>{loading ? "Generating..." : "Generate Report"}</button>
          {report && <button type="button" onClick={() => window.print()}>Print / Save PDF</button>}
          {report && <button type="button" onClick={() => exportCsv(report)}>Export To Excel</button>}
        </div>
      </section>

      {report && (
        <section className="crystal-sheet">
          <header className="crystal-report-header">
            <h1>{company.CompanyName || "Global Metals"}</h1>
            <h2>{report.report.title}</h2>
            <div>
              <span>Crystal Source: {report.report.sourceFile}</span>
              <span>Report ID: {report.report.oldReportId}</span>
              <span>Generated: {formatDate(report.criteria.generatedAt)}</span>
            </div>
          </header>
          <ReportBody report={report} />
        </section>
      )}

      {!report && (
        <section className="crystal-sheet crystal-placeholder">
          <header className="crystal-report-header">
            <h1>Global Metals</h1>
            <h2>{selectedReport.label}</h2>
            <div><span>Crystal Source: {selectedReport.file}</span></div>
          </header>
        </section>
      )}
    </div>
  );
};

export default CrystalReports;
